module.exports = __webpack_public_path__ + "img/135.b285ca44.jpg";